var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.221,
    height: 12.614,
    viewBox: "0 0 18.221 12.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-256.454 -242.583)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.454 242.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.39,82.807a3.154,3.154,0,1,0-3.195-3.154A3.184,3.184,0,0,0,159.39,82.807Zm9.435-2.027V78.415h-1.6V80.78h-2.4v1.577h2.4v2.365h1.6V82.357h2.4V80.78Zm-9.435,3.6c-2.156,0-6.39,1.025-6.39,3.154v1.577h12.779V87.538C165.779,85.409,161.546,84.384,159.39,84.384Z",
    transform: "translate(-153 -76.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.9d97899dd415b874a44977dd4fa8cc24.svg";
export { ForwardRef as ReactComponent };